import React, { useState } from "react";
import { MoodleQuizList } from "../../features/Moodle/MoodleQuizes";
import { MoodleGameWidget } from "../../widgets/MoodleGameWidget";

const MoodlePage = () => {
  const [courseId, setCourseId] = useState("2");

  return (
    <div>
      <MoodleQuizList courseId={courseId} setCourseId={setCourseId} />
      <MoodleGameWidget courseId={courseId} />
    </div>
  );
};

export default MoodlePage;